/**
 * SeoFilterAndDisplay Functional Component
 * @Package - seo
 * @Author - Cybage@UPWA-Team
 * @description: Common SEO FilterAndDisplay
 */
/**
 *   SEO's FilterAndDisplay Component
 */
import React, { useMemo, memo } from 'react'
import { UserInfoMsg } from '@usap/widgets'
import { Box, InfoOutlineIcon } from '@usap/uicomponents'
import SearchLayout from '../common/SearchLayout'
import { useVehicleContext } from '../../contexts/vehicle.context'

const style = {
  margin: { vertical: '0px', horizontal: 'auto' },
  pad: { horizontal: 'small' },
  width: '1248px',
}

function SeoFilterAndDisplay({
  id,
  dynamicApiData,
  isComponentChanged,
  sortOptions,
  coreConfig,
}) {
  const vehicle = useVehicleContext()

  const products = useMemo(
    () => (dynamicApiData && dynamicApiData.products) || {},
    [dynamicApiData],
  )

  const pageType = useMemo(
    () => (dynamicApiData && dynamicApiData.pageType) || '',
    [dynamicApiData],
  )

  const hasProducts = useMemo(
    () => Boolean(Object.keys(products).length),
    [products],
  )

  const noProducts = useMemo(
    () => Boolean(!hasProducts),
    [hasProducts],
  )

  const pageTypeBrand = useMemo(
    () => Boolean(dynamicApiData && dynamicApiData.pageType === 'brand'),
    [dynamicApiData],
  )

  const brandCheckForProducts = useMemo(
    () => Boolean(pageTypeBrand && noProducts),
    [pageTypeBrand, noProducts],
  )

  const headings = useMemo(
    () => dynamicApiData && dynamicApiData.headings,
    [dynamicApiData],
  )

  const productTitle = useMemo(
    () => (headings && headings.products) || 'Product',
    [headings],
  )

  if (brandCheckForProducts) {
    return null
  }

  if (noProducts) {
    const title = dynamicApiData.header || 'Product'
    const vehicleDBLength = vehicle?.vehicleDB?.length || 0
    const moreInfo = vehicleDBLength ? ' products available for your vehicle.' : '.'

    return (
      <Box
        margin={style.margin}
        width={style.width}
        pad={style.pad}
      >
        <UserInfoMsg
          bgColor="orange"
          icon={InfoOutlineIcon}
          infoType={`We do not have any compatible <b>${title}</b>${moreInfo}`}
        />
      </Box>
    )
  }

  return (
    <SearchLayout
      id={id}
      isComponentChanged={isComponentChanged}
      sortOptions={sortOptions}
      isSearch={false}
      title={productTitle}
      products={products}
      removePrice={false}
      pageType={pageType}
      coreConfig={coreConfig}
    />
  )
}

export default memo(SeoFilterAndDisplay)
